import { Tooltip } from './Tooltip';

// TODO: in v9, move styled() from Tooltip.jsx to here
export var StyledTooltip = Tooltip;